<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-ai-profit"></i>月利润信息浏览
      <el-tooltip class="item" effect="dark" placement="top">
        <!--  显示的问号  -->
        <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
        <!--  提示插槽      -->
        <div slot="content">
          <!-- <p>Tips：除利润金额是人民币外，其他属于站点对应国家的国币。</p> -->
        </div>
      </el-tooltip>
    </div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="110px" size="small" :model="formInline">
        <el-form-item label="查询月份：">
          <el-date-picker v-model="belongMonthly" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月"> </el-date-picker>
        </el-form-item>
        <el-form-item label="店铺名称：">
          <el-select v-model="formInline.shopId" clearable filterable placeholder="请选择" @change="queryrealChange">
            <!-- <el-option label="请选择" value /> -->
            <el-option v-for="types in dataShops" :key="types.id" :value="types.id" v-text="types.shopName" :label="types.shopName" />
          </el-select>
        </el-form-item>
        <el-form-item label="站点：">
          <el-select v-model="formInline.site" style="width: 100%" clearable placeholder="请选择">
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
          <el-button type="primary" @click="importInfo('trigger')" style="backgroundcolor: #2a3861; bordercolor: transparent">指定月份计算 </el-button>
          <!-- <el-button
                type="primary"
                @click="importInfo('import')"
                style="backgroundcolor: #2a3861; bordercolor: transparent"
                >导入
              </el-button> -->
          <el-button type="primary" @click="exportSkuInfo()" style="backgroundcolor: #2a3861; bordercolor: transparent">导出 </el-button>
          <el-button type="primary" @click="importInfo('export-site-data')" style="backgroundcolor: #2a3861; bordercolor: transparent">头程明细导出 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100% - 120px)"
        :data="transData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        :row-class-name="rowClass"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column v-for="(item, index) in transTitle" :label="item + ''" :key="index" align="center">
          <template slot-scope="scope">
            {{ scope.row[index] }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增弹框 -->
      <el-dialog title="指定月份数据拉取计算" width="600px" :visible.sync="addRoleDialog" :close-on-click-modal="true" :show-close="false" left>
        <el-form label-width="130px" :model="addrole" ref="addrole" :rules="rules1">
          <el-form-item label="拉取月份：" prop="belongMonthly">
            <el-date-picker style="width: 100%" v-model="addrole.belongMonthly" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancelSku()">取 消</el-button>
            <el-button @click="triggerBxd()" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 头程明细导出 -->
      <el-dialog title="头程明细导出" width="600px" :visible.sync="exportSiteData" :close-on-click-modal="true" :show-close="false" left>
        <el-form label-width="130px" :model="exportDetailDataForm" ref="exportDetailDataForm" :rules="exportDetailRule">
          <el-form-item label="导出月份：" prop="belongMonthlyList">
            <el-date-picker type="months" multiple style="width: 100%" v-model="exportDetailDataForm.belongMonthlyList" placeholder="选择一个月或多个月" format="yyyy-MM" value-format="yyyy-MM"> </el-date-picker>
            <!-- <el-date-picker style="width: 100%" v-model="exportDetailDataForm.belongMonthlyList" format="yyyy-MM" value-format="yyyy-MM" type="months" placeholder="选择月">
            </el-date-picker> -->
          </el-form-item>
          <el-form-item label="店铺名称：" prop="shopNames">
            <el-select style="width: 100%" multiple v-model="exportDetailDataForm.shopNames" clearable filterable placeholder="请选择">
              <el-option v-for="types in dataShops" :key="types.shopName" :value="types.shopName" v-text="types.shopName" :label="types.shopName" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="importCancel()">取 消</el-button>
            <el-button @click="exportDetailData()" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- 新增弹框 -->
      <el-dialog title="导入月利润数据" width="600px" :visible.sync="importDialog" :close-on-click-modal="true" :show-close="false" left>
        <el-form label-width="130px" :model="upload" ref="upload" :rules="uploadrules1">
          <el-form-item label="导入月份：" prop="belongMonthly">
            <el-date-picker style="width: 100%" v-model="upload.belongMonthly" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="店铺名称：" prop="shopId">
            <el-select style="width: 100%" v-model="upload.shopId" clearable filterable placeholder="请选择" @change="ImportChange">
              <el-option v-for="types in dataShops" :key="types.id" :value="types.id" v-text="types.shopName" :label="types.shopName" />
            </el-select>
          </el-form-item>
          <el-form-item label="站点：" prop="site">
            <el-select v-model="upload.site" style="width: 100%" clearable placeholder="请选择">
              <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
            </el-select>
          </el-form-item>

          <el-form-item label="上传文件：">
            <el-upload
              class="upload-demo"
              drag
              ref="upload"
              :multiple="false"
              action="javascript:void(0)"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="submitUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button @click="importCancel()">取 消</el-button>
            <el-button @click="importData()" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    belongMonthly(val) {
      if (val == null) {
        this.belongMonthly = getPreMonth();
      }
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      file: {},
      dataShops: [],
      /*创建角色*/
      addRoleDialog: false,
      exportSiteData: false,
      addrole: {
        belongMonthly: "",
        shopId: "",
        shopName: "",
        site: "",
      },
      modelTitle: "",
      /*编辑角色*/
      editRoleDialog: false,
      editrole: {
        id: undefined,
        name: "",
        description: "",
        authorityIds: [],
      },
      rules1: {
        belongMonthly: [{ required: true, message: "月份是必填的", trigger: "change" }],
        shopId: [{ required: true, message: "店铺是必填的", trigger: "change" }],
        site: [{ required: true, message: "站点是必填的", trigger: "change" }],
      },
      uploadrules1: {
        belongMonthly: [{ required: true, message: "月份是必填的", trigger: "change" }],
        shopId: [{ required: true, message: "店铺是必填的", trigger: "change" }],
        site: [{ required: true, message: "站点是必填的", trigger: "change" }],
      },
      exportDetailRule: {
        belongMonthlyList: [{ required: true, message: "月份是必选的", trigger: "change" }],
        shopNames: [{ required: true, message: "店铺是必选的", trigger: "change" }]
      },
      importDialog: false,
      exportSiteData: false,
      data: [{}] /*绑定新增角色树的数据*/,
      formInline: {
        belongMonthly: "",
        shopId: "",
        shopName: "",
        site: "",
      },
      belongMonthly: this.getPreMonth(),
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      uploadDialog: false,
      upload: {
        name: "",
        belongMonthly: new Date(),
        shopId: "",
        shopName: "",
        site: "",
        chunks: 1,
        ext: "",
      },
      exportDetailDataForm: {
        belongMonthlyList: [],
        shopNames: []
      },
      fileList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      dataSites: [],
      flagClick: false,
      // 双击修改
      attribute: false,
      cost: false,
      failReason: false,
      fnsku: false,
      numberPackages: false,
      packagesHigh: false,
      packagesLong: false,
      packagesWeight: false,
      packagesWide: false,
      shopName: false,
      site: false,
      sku: false,
      type: false,
      diaType: "",
      originData: [
        {
          type: "选择题",
          num: "5题",
          average: "3分/题",
        },
        {
          type: "填空题",
          num: "5题",
          average: "3分/题",
        },
        {
          type: "选择题",
          num: "2题",
          average: "10分/题",
        },
      ],
      originTitle: [
        "月份",
        // "名称",
        "站点",
        "月总销售额",
        "亚马逊物流赔偿金额",
        "买家支付的运费",
        "邮费积分",
        "买家支付礼品卡金额",
        "退款中的亚马逊物流交易费返款",
        "退款中的平台费返款",
        "退货后的促销返款",
        "销售退款总额",
        "退款中的运费",
        "促销折扣额/促销回报",
        "退款管理费",
        "退款中的积分费用",
        "广告费用",
        "尾程配送费",
        "平台佣金扣点",
        "秒杀费用",
        "Coupon费用",
        "店租",
        "FBA库存仓储费",
        "其他",
        "VAT消费税",
        "汇率",
        "推广费",
        "商品成本",
        "商品头程",
        "利润（人民币）",
        "利润率",
        "店铺压货成本",
        "自配送尾程配送费",
        "下单商品成本",
        "广告退款额",
        "早期评论人计划",
        "VINE",
        // "月度利润",
        "成本占比",
        "头程比",
        "fba运费比",
        "广告支出比",
        "投产占比"
      ], // originTitle 该标题为 正常显示的标题, 数组中的顺序就是上面数据源对象中的字段标题对应的顺序
      transTitle: [], // transTitle 该标题为转化后的标题, 注意多一列,  因为原来的标题变成了竖着显示了, 所以多一列标题, 第一个为空即可
      transData: [],
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
    this.getAllSites();
  },
  methods: {
    rowClass({ row, column, rowIndex, columnIndex }) {
      //console.log(row + '_' + column + '_' +rowIndex + '_' + columnIndex)
      if (rowIndex == 1) {
        //console.log(rowIndex, 'aaa')
        return "fixed-row";
      }
    },
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/shop/list").then((r) => {
        if (r.data.code == 200) {
          let data = r.data.data;
          this.dataShops = data;
        }
      });
    },
    getAllSites() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf("1120") == 0) {
            // 品牌
            this.dataBrands = data[key];
          }
          if (key.indexOf("1130") == 0) {
            // 站点
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + "（" + item.codeName + "）";
            });
            this.dataSites = siteData;
          }
        }
      });
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      //console.log(resp.data, 'resp.data')
      this.$data.tableData = resp.data.data && resp.data.data ? resp.data.data : [];

      // 数组按矩阵思路, 变成转置矩阵
      if (this.$data.tableData.length > 0) {
        let shopNameArr = [];
        let shopI = 0;
        let matrixData = this.$data.tableData.map((row) => {
          let arr = [];
          for (let key in row) {
            if (key == "belongMonthly") {
              arr[0] = moment(row[key]).format("YYYY-MM");
            } 
            // else if (key == "shopName") {
            //   arr[1] = row[key];
            // } 
            else if (key == "site") {
              arr[1] = row[key];
            } else if (key == "yzxse") {
              arr[2] = row[key];
            } else if (key == "ymxwlpcje") {
              arr[3] = row[key];
            } else if (key == "mjzfyf") {
              arr[4] = row[key];
            } else if (key == "yfjf") {
              arr[5] = row[key];
            } else if (key == "mjzflpkje") {
              arr[6] = row[key];
            } else if (key == "tkzdymxwljyffk") {
              arr[7] = row[key];
            } else if (key == "tkzdptffk") {
              arr[8] = row[key];
            } else if (key == "thgdcxfk") {
              arr[9] = row[key];
            } else if (key == "xstkze") {
              arr[10] = row[key];
            } else if (key == "tkzdyf") {
              arr[11] = row[key];
            } else if (key == "cxzkehb") {
              arr[12] = row[key];
            } else if (key == "tkglf") {
              arr[13] = row[key];
            } else if (key == "tkzdjffy") {
              arr[14] = row[key];
            } else if (key == "ggfy") {
              arr[15] = row[key];
            } else if (key == "wcpsf") {
              arr[16] = row[key];
            } else if (key == "ptyjkd") {
              arr[17] = row[key];
            } else if (key == "msfy") {
              arr[18] = row[key];
            } else if (key == "coupon") {
              arr[19] = row[key];
            } else if (key == "dz") {
              arr[20] = row[key];
            } else if (key == "fbakcccf") {
              arr[21] = row[key];
            } else if (key == "qt") {
              arr[22] = row[key];
            } else if (key == "vatxfs") {
              arr[23] = row[key];
            } else if (key == "rate") {
              arr[24] = row[key];
            } else if (key == "tgf") {
              arr[25] = row[key];
            } else if (key == "spcb") {
              arr[26] = row[key];
            } else if (key == "sptc") {
              arr[27] = row[key];
            } else if (key == "profit") {
              arr[28] = row[key];
            } else if (key == "profitMargin") {
              arr[29] = row[key];
            } else if (key == "dpyhcb") {
              arr[30] = row[key];
            } else if (key == "zpswcpsf") {
              arr[31] = row[key];
            } else if (key == "xdcb") {
              arr[32] = row[key];
            } else if (key == "ggtke") {
              arr[33] = row[key];
            } else if (key == "zqplrjh") {
              arr[34] = row[key];
            } else if (key == "vine") {
              arr[35] = row[key];
            } 
            // else if (key == "monthlyProfit") {
            //   arr[35] = row[key];
            // } 
            else if (key == "costProfit") {
              arr[36] = row[key];
            } else if (key == "tcProfit") {
              arr[37] = row[key];
            } else if (key == "fbaDeliveryProfit") {
              arr[38] = row[key];
            } else if (key == "advertProfit") {
              arr[39] = row[key];
            } else if (key == "tczbProfit") {
              arr[40] = row[key];
            }
            else if (key == "shopName") {
              shopNameArr[shopI] = row[key];
              shopI = shopI + 1;
            }
          }
          return arr;
        });
        //console.log(matrixData)
        // 加入标题拼接最终的数据
        if (matrixData.length > 0) {
          this.transData = matrixData[0].map((col, i) => {
            return [
              this.originTitle[i],
              ...matrixData.map((row) => {
                return row[i]; //因为数据多出一行，需要从索引1开始
              }),
            ];
          });
          this.transTitle = shopNameArr.map((col, i) => {
            return col;
          });
          this.transTitle.unshift("");
        }
      }
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },

    query() {
      this.transData = [];
      this.transTitle = [];
      //条件筛选
      //this.formInline.belongMonthly = this.belongMonthly;
      let o = {
        ...this.formInline,
      };
      if (this.belongMonthly != null && this.belongMonthly != "" && this.belongMonthly != undefined) {
        o.belongMonthly = moment(this.belongMonthly).format("YYYY-MM");
      } else {
        delete o.belongMonthly;
        o.belongMonthly = this.getPreMonth();
      }
      this.axios.get("/api/monthly-profit/list", {
          // , sku: this.$data.formInline.sku, type: this.$data.formInline.type
          params: { ...o },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },

    getPreMonth() {
      var cur = new Date();
      if (cur.getMonth() == 0) {
        return (cur.getFullYear() - 1) + "-12"; 
      }
      return cur.getFullYear() + "-" + this.checkMonth(cur.getMonth());
    },
    checkMonth(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    cancelSku() {
      this.addrole = {
        belongMonthly: "",
        shopId: "",
        shopName: "",
      };
      this.addRoleDialog = false;
      this.exportSiteData = false;
    },

    queryrealChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      console.log(obj.shopName, "shopName");
      this.formInline.shopName = obj.shopName;
    },
    realChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      console.log(obj.shopName, "shopName");
      this.addrole.shopName = obj.shopName;
    },
    ImportChange(val) {
      var obj = {};
      obj = this.dataShops.find(function(i) {
        return i.id === val;
      });
      this.upload.shopName = obj.shopName;
    },
    // exportDetailChange(val) {
    //   console.log('val', val)
    //   var obj = {};
    //   obj = this.dataShops.find(function(i) {
    //     return i.id === val;
    //   });
    //   console.log('----', obj)
    //   this.exportDetailDataForm.shopNames = obj.shopName;
    // },
    // 导入
    importInfo(type) {
      this.diaType = type;
      if (type == "trigger") {
        // this.modelTitle = '触发报销单'
        this.addRoleDialog = true;
      } else if (type == "import") {
        // this.modelTitle = '导入'
        this.importDialog = true;
      } else if (type == "export-site-data") {
        this.exportSiteData = true;
      }
    },
    triggerBxd() {
      /*触发报销单*/
      this.$refs["addrole"].validate((valid) => {
        if (valid) {
          let role = { ...this.addrole };
          //console.log(this.addrole, 'this.addrole')
          role.belongMonthly = moment(role.belongMonthly).format("YYYY-MM");
          this.axios.get("/api/monthly-profit/calculation", { params: { ...role } }).then((r) => {
            console.log(r, '请求接口：')
            if (r.data.code == 200) {
              this.$message.info(r.data.msg);
              this.cancelSku();
              this.query();
            } else {
              this.$message.error(r.data.msg);
            }
          });
        }
      });
    },
    // 头程明细导出
    exportDetailData() {
      if (this.exportDetailDataForm.belongMonthlyList.length <= 0 || this.exportDetailDataForm.shopNames <= 0) {
        this.$message.error("请选择导出月份或店铺！");
        return;
      }
      let baseurl = this.axios.defaults.baseURL;
      let path = '/api/monthly-profit/export-site-data?';
      if (this.exportDetailDataForm.belongMonthlyList) {
        path += "&belongMonthlyList=" + this.exportDetailDataForm.belongMonthlyList;
      }
      if (this.exportDetailDataForm.shopNames) {
        path += "&shopNames=" + this.exportDetailDataForm.shopNames;
      }
      this.axios({
        url: path,
        method: 'get',
        responseType: 'blob',
      }).then(res => {
          console.log('res', res);
          this.downloadCallback(res, '站点、头程明细数据.xlsx');
          this.exportDetailDataFormCancel();
        }
      ).catch(err => {
        console.log(err.message);
        this.exportDetailDataFormCancel();
      });
    },
    exportSkuInfo() {
      this.$msgbox
        .confirm("此操作将导出月利润信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let baseurl = this.axios.defaults.baseURL;
          let path = '/api/monthly-profit/export?1=1';
          if (this.belongMonthly != null && this.belongMonthly != "") {
            path += "&belongMonthly=" + this.belongMonthly;
          } 
          if (this.formInline.shopId) {
            path += "&shopId=" + this.formInline.shopId;
          }
          if (this.formInline.shopName) {
            path += "&shopName=" + this.formInline.shopName;
          }
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              console.log('res', res);
              this.downloadCallback(res, '月利润报表.xlsx');
            }
          ).catch(err => {
            console.log(err.message);
          });
          // window.open(path, "_blank");
          // /*加个下载成功的进度条*/
          // setTimeout(() => {
          //   this.$message({
          //     message: "下载成功",
          //     type: "success",
          //     center: true,
          //   });
          // }, 500);
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    // 导入数据
    importData() {
      this.$refs["upload"].validate((valid) => {
        if (valid) {
          if (!this.upload.name) {
            this.$message.error("请先选择文件！");
            return;
          }
          let o = {};
          o.belongMonthly = moment(this.upload.belongMonthly).format("YYYY-MM");
          o.shopId = this.upload.shopId;
          o.shopName = this.upload.shopName;
          o.site = this.upload.site;
          let formData = new FormData();
          // 向 formData 对象中添加文件
          formData.append("dto", JSON.stringify(o));
          formData.append("file", this.upload.file.raw);
          let config = {
            //添加请求头
            headers: { "Content-Type": "multipart/form-data" },
            //添加上传进度监听事件
            onUploadProgress: (e) => {
              var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
              this.progress = completeProgress;
            },
          };
          this.$http.post("/api/monthly-profit/import", formData, config).then(
            (resp) => {
              let baseurl = this.axios.defaults.baseURL;
              this.upload = {};
              if (resp.data.code == 200) {
                // 导入正确
                // failFilePath有的话是导入条目失败了 有失败原因
                // if (resp.data.data.failFilePath) {
                //   window.open(
                //     `${baseurl}/api/sku-info/templateDownload?path=` + path,
                //     "_blank"
                //   );
                // } else {
                //   this.$message("上传成功");
                //   this.query();
                //   this.importCancel()
                // }
                // 提示导入信息
                setTimeout(() => {
                  this.$message(resp.data.msg);
                  this.query();
                  this.importCancel();
                }, 3000);
              } else {
                this.$message.info(resp.data.msg);
                this.importCancel();
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        }
      });
    },
    submitUpload(file, fileList) {
      // console.log(file, 'ssssssssss');
      this.file = file;
      let s = file.name;
      this.upload.ext = s.substr(s.lastIndexOf(".") > 0 ? s.lastIndexOf(".") + 1 : 0);
      this.fileList = fileList.slice(-1);
      this.upload.name = file.name;
      this.upload.file = file;
    },
    importCancel() {
      this.fileList = [];
      this.upload = {
        name: "",
        belongMonthly: new Date(),
        shopId: "",
        site: "",
        shopName: "",
        chunks: 1,
        ext: "",
      };
      this.importDialog = false;
    },
    exportDetailDataFormCancel(){
      this.exportDetailDataForm = {
        belongMonthlyList: [],
        shopNames: []
      }
      this.exportSiteData = false;
    }
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #8691c9;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form {
      width: 100%;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #8691c9;
}

.el-table .fixed-row {
  display: table-row;
  position: sticky;
  height: auto !important;
  // position: "-webkit-sticky";
  //background: #303035 !important;
  top: 0;
  width: 100%;
  // td {
  //   //  border: 1px solid #181922;
  //   background: #323233 !important;
  // }
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
